import React from 'react';

type StatusType = 'online' | 'offline' | 'warning' | 'critical' | 'info' | 'future' | 'resolved' | 'open' | 'in_progress' | 'commissioned' | 'pending' | 'under_test' | 'inactive' | 'review' | 'clear' | 'normal' | 'urgent';

interface StatusPillProps {
  status: StatusType;
  label?: string;
  dashed?: boolean;
}

const statusConfig: Record<StatusType, { bg: string; text: string; label: string }> = {
  online:       { bg: 'bg-green-100',  text: 'text-success',  label: 'Online' },
  offline:      { bg: 'bg-red-100',    text: 'text-danger',   label: 'Offline' },
  warning:      { bg: 'bg-orange-100', text: 'text-warning',  label: 'Warning' },
  critical:     { bg: 'bg-red-100',    text: 'text-danger',   label: 'Critical' },
  info:         { bg: 'bg-blue-100',   text: 'text-accent',   label: 'Info' },
  future:       { bg: 'bg-purple-100', text: 'text-purple',   label: 'Future Phase' },
  resolved:     { bg: 'bg-green-100',  text: 'text-success',  label: 'Resolved' },
  open:         { bg: 'bg-orange-100', text: 'text-warning',  label: 'Open' },
  in_progress:  { bg: 'bg-blue-100',   text: 'text-accent',   label: 'In Progress' },
  commissioned: { bg: 'bg-green-100',  text: 'text-success',  label: 'Commissioned' },
  pending:      { bg: 'bg-orange-100', text: 'text-warning',  label: 'Pending' },
  under_test:   { bg: 'bg-blue-100',   text: 'text-accent',   label: 'Under Test' },
  inactive:     { bg: 'bg-gray-100',   text: 'text-gray-500', label: 'Inactive' },
  review:       { bg: 'bg-orange-100', text: 'text-warning',  label: 'Review' },
  clear:        { bg: 'bg-green-100',  text: 'text-success',  label: 'Clear' },
  normal:       { bg: 'bg-green-100',  text: 'text-success',  label: 'Normal' },
  urgent:       { bg: 'bg-red-100',    text: 'text-danger',   label: 'Urgent' },
};

export default function StatusPill({ status, label, dashed = false }: StatusPillProps) {
  const config = statusConfig[status] || statusConfig.info;
  const displayLabel = label ?? config.label;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-pill text-xs font-medium ${config.bg} ${config.text} ${dashed ? 'border border-dashed border-current' : ''}`}
    >
      {displayLabel}
    </span>
  );
}
